module.exports = __webpack_public_path__ + "media/images/lb/335-e53e7d71af91071eb8ae0979b0473f42.svg";